import { render, staticRenderFns } from "./PrintifyConfigurator.vue?vue&type=template&id=51036d0a&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./PrintifyConfigurator.vue?vue&type=style&index=0&id=51036d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51036d0a",
  null
  
)

export default component.exports